import { render, staticRenderFns } from "./TheSeoNavigation.vue?vue&type=template&id=020b8254"
import script from "./TheSeoNavigation.vue?vue&type=script&lang=ts"
export * from "./TheSeoNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports